import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M38.80 63Q36.05 63 33.83 61.63Q31.60 60.25 30.30 57.95Q29 55.65 29 52.80L29.05 37.20Q29.05 34.45 30.32 32.17Q31.60 29.90 33.83 28.52Q36.05 27.15 38.80 27.15Q41.55 27.15 43.75 28.50Q45.95 29.85 47.25 32.13Q48.55 34.40 48.55 37.20L48.55 39.50Q48.55 39.70 48.35 39.70L42.75 39.70Q42.55 39.70 42.55 39.50L42.55 37.20Q42.55 35.55 41.47 34.35Q40.40 33.15 38.80 33.15Q37 33.15 36.05 34.38Q35.10 35.60 35.10 37.20L35.10 52.80Q35.10 54.65 36.18 55.80Q37.25 56.95 38.80 56.95Q40.40 56.95 41.47 55.67Q42.55 54.40 42.55 52.80L42.55 50.50Q42.55 50.30 42.75 50.30L48.40 50.30Q48.60 50.30 48.60 50.50L48.60 52.80Q48.60 55.65 47.28 57.95Q45.95 60.25 43.75 61.63Q41.55 63 38.80 63Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
